import { BadgeColor } from "@/components/catalyst/badge";
import { AgentRunKind, AgentRunState } from "@/gql/graphql";

export const AGENT_RUN_STATE_TONE: Record<AgentRunState, BadgeColor> = {
  [AgentRunState.Done]: "green",
  [AgentRunState.NeedsAttention]: "amber",
  [AgentRunState.NotRelevant]: "zinc",
  [AgentRunState.Processing]: "blue",
  [AgentRunState.Failed]: "red",
};

export const AGENT_RUN_KIND_LABEL: Record<AgentRunKind, string> = {
  [AgentRunKind.MailboxEmail]: "Email",
  [AgentRunKind.ThlListImport]: "THL list",
};
